export const ROOM_DAILY_SUMMARY_API = '/live/saada/room_daily_summary'
